import { View, Text, TouchableOpacity, Pressable } from 'react-native'
import { fontPalette, globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../../components/home/HomeDetailsHeader'
import Card from '../../../components/shared/card/Card'
import CardSeparator from '../../../components/shared/card/CardSeparator'
import moment from 'moment'
import { useEffect, useMemo, useState } from 'react'
import { useHomeStore } from '../../../stores/home'
import { useLabourStore } from '../../../stores/labour'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useclockstore } from '../../../stores/clock'
import { convertTo12HourTime, getLocalTimeWithTimezoneOffset } from '../../../utils'
import Toast from 'react-native-toast-message'
import { getCurrentLocationAndCheckQuadrilateral } from '../../../helpers/geoFencingHelper'
import { ActivityIndicator } from 'react-native-paper'
import { useTranslation } from 'react-i18next'
import { Loading } from '../../../components/shared/navigator/Loading'

const Endbreak = ({ navigation, route }) => {
  const [currentTime, setCurrentTime] = useState(new Date())
  const homestore = useHomeStore()
  const labourStore = useLabourStore()
  const personastore = usePersonalStore()
  const clockstore = useclockstore()
  const { params } = route
  const {
    mostRecentUserOnBoardings: userId,
    relationships,
    isClockIn,
    setClockIn,
    breaktype,
    shiftid
  } = params
  const [loader, setLoader] = useState(false)
  const personalstore = usePersonalStore()
  const [selectedDepartment, setSelectedDepartment] = useState<any>(null)
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date())
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  const formattedTime = currentTime.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  })
  const shiftdetails = useMemo(() => {
    return labourStore.scheduleData?.shiftInfo?.find((item: any) => item.shiftID == shiftid)
  }, [labourStore.scheduleData, shiftid])

  useEffect(() => {

    clockstore.fetchdepartments(
      personalstore.personalData.entityId,
      homestore.homeData.laborSaverStoreID,
      labourStore?.labourData?.userId ? labourStore?.labourData?.userId : 0
    )
  }, [])

  useEffect(() => {
    const selectedDepartmentDetails = clockstore?.departmentsData?.data?.find((item) => item.department_Focus == clockstore?.departmentsData?.currentFocusDepartmentId);
    setSelectedDepartment(selectedDepartmentDetails)
  }, [clockstore?.departmentsData?.data])

  const data = {
    EssUserOnboardingKey: userId,
    entityId: personastore?.personalData?.entityId,
    corporationId: personastore?.personalData?.corpEntityId,
    storeId: homestore?.homeData?.storeNumber,
    employeeId: labourStore?.labourData?.employeeNumber,
    shiftId: shiftdetails?.shiftID,
    userId: labourStore?.labourData?.userId ? labourStore?.labourData?.userId : 0,
    departmentId: clockstore?.departmentsData?.currentFocusDepartmentId,
    inType: breaktype,
    attendanceDate: new Date(),
    // clockPunchTime: getLocalTimeWithTimezoneOffset(),
    clockPunchTime: new Date().toISOString()
  }

  const handleSubmit = async () => {
    // const flag =
    //   !homestore.homeData?.geofencingStatus &&
    //   homestore.homeData?.coordinateOneLatitude != null
    // if (flag) {
    //   const topLeft = [
    //     homestore.homeData.coordinateOneLatitude,
    //     homestore.homeData.coordinateOneLongitude
    //   ]
    //   const topRight = [
    //     homestore.homeData.coordinateTwoLatitude,
    //     homestore.homeData.coordinateTwoLongitude
    //   ]
    //   const bottomRight = [
    //     homestore.homeData.coordinateThreeLatitude,
    //     homestore.homeData.coordinateThreeLongitude
    //   ]
    //   const bottomLeft = [
    //     homestore.homeData.coordinateFourLatitude,
    //     homestore.homeData.coordinateFourLongitude
    //   ]
    //   try {
    //     setLoader(true)
    //     const empLocation = null
    //     const res = await getCurrentLocationAndCheckQuadrilateral(
    //       topLeft,
    //       topRight,
    //       bottomLeft,
    //       bottomRight,
    //       empLocation
    //     )
    //     if (res) {
    //       await clockstore.postclockin(data)
    //       navigation.navigate('LabourScreen')
    //     } else {
    //       Toast.show({
    //         type: 'error',
    //         position: 'bottom',
    //         text1: t('Cannot submit Clock In from outside the store'),
    //         visibilityTime: 5000,
    //         autoHide: true,
    //         topOffset: 60
    //       })
    //     }
    //   } catch (error) {
    //     console.log(error)
    //   } finally {
    //     setLoader(false)
    //   }
    // } 
    // else {
    await clockstore.postclockin(data)
    navigation.navigate('LabourScreen')
    // }
  }
  const { t } = useTranslation()

  if (clockstore?.loading) return <Loading />

  return (
    <>
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader />
        </View>
        <View style={[globalStyles.vCenterItems]}>
          <Text
            style={[
              globalStyles.text,
              globalStyles.fwBold,
              globalStyles.fs30,
              globalStyles.whiteTextColor,
              globalStyles.textCenter
            ]}
          >
            {breaktype === 'MEAL_END' ? t('End Meal Break') : t('End Break')}
          </Text>
          <TouchableOpacity
            style={{
              marginTop: 20,
              borderRadius: 5,
              backgroundColor: '#4FC7E8',
              width: '90%'
            }}
            onPress={() => navigation.navigate('LabourScreen')}
          >
            <Text
              style={{
                color: 'white',
                fontSize: 20,
                textAlign: 'center',
                padding: 10,
                fontFamily:fontPalette.primaryBold
              }}
            >
              {t('cancel')}
            </Text>
          </TouchableOpacity>
        </View>
      </View>
      <View
        style={{
          marginTop: -44,
          padding: 16,
          flex: 1,
          justifyContent: 'space-between'
        }}
      >
        <Card>
          <View>
            <Text style={{ fontSize: 30, fontWeight: 'bold' ,fontFamily:fontPalette.primaryRegular}}>
              {formattedTime}
            </Text>
            <CardSeparator />
            <Text
              style={[
                globalStyles.inputLabel,
                globalStyles.inputLabelLarge,
                globalStyles.inputLabelPrimary,
              ]}
            >
              {t('Scheduled Shift')}
            </Text>

            <Text style={{ fontSize: 18,fontFamily:fontPalette.primaryRegular }}>
              {moment(shiftdetails?.date).format('MMM D')},{' '}
              {convertTo12HourTime(shiftdetails?.time_In)} -{' '}
              {convertTo12HourTime(shiftdetails?.time_Out)}
            </Text>
            <View style={[{ width: '100%', marginRight: '2%' }]}>
              <Text
                style={[
                  globalStyles.inputLabel,
                  globalStyles.inputLabelLarge,
                  globalStyles.inputLabelPrimary,
                  { marginTop: 10 }
                ]}
              >
                {t('store')}
              </Text>

              <Text style={{ fontSize: 18,fontFamily:fontPalette.primaryRegular }}>
                {homestore?.homeData?.storeName}
              </Text>
            </View>

            <View style={[{ width: '100%', marginRight: '2%' }]}>
              <Text
                style={[
                  globalStyles.inputLabel,
                  globalStyles.inputLabelLarge,
                  globalStyles.inputLabelPrimary,
                  { marginTop: 10 }
                ]}
              >
                {t('Department')}
              </Text>

              <Text style={{ fontSize: 18,fontFamily:fontPalette.primaryRegular }}>
                {/* {homestore.homeData.deptName} */}
                {selectedDepartment?.depName}
              </Text>
            </View>
          </View>
        </Card>
        {loader && <ActivityIndicator />}
        {!loader && (
          <TouchableOpacity
            style={{
              marginTop: 20,
              borderRadius: 5,
              backgroundColor: '#9DD086',
              width: '90%',
              alignSelf: 'center'
            }}
            onPress={async () => {
              handleSubmit()
            }}
          >
            <Text
              style={{
                color: 'white',
                fontSize: 20,
                textAlign: 'center',
                padding: 10,
                fontFamily:fontPalette.primaryBold
              }}
            >
              {breaktype === 'MEAL_END' ? t('End Meal Break') : t('End Break')}
            </Text>
          </TouchableOpacity>
        )}
      </View>

    </>
  )
}
export default Endbreak
